export const provinces = {
  "Metro Manila": [
    "Manila", "Quezon City", "Makati", "Taguig", "Pasig",
    "Parañaque", "Mandaluyong", "Pasay", "Caloocan", "Marikina",
    "Las Piñas", "Muntinlupa", "Valenzuela", "San Juan", "Malabon"
  ],
  "Cebu": [
    "Cebu City", "Mandaue", "Lapu-Lapu", "Talisay", "Danao",
    "Carcar", "Naga", "Toledo", "Bogo", "Minglanilla",
    "Consolacion", "Liloan", "Compostela", "Cordova", "Dalaguete"
  ],
  "Davao del Sur": [
    "Davao City", "Digos", "Bansalan", "Magsaysay", "Matanao",
    "Hagonoy", "Kiblawan", "Padada", "Sulop", "Santa Cruz"
  ],
  "Bohol": [
    "Tagbilaran", "Panglao", "Dauis", "Baclayon", "Loboc",
    "Carmen", "Tubigon", "Talibon", "Ubay", "Jagna",
    "Loon", "Alburquerque", "Corella", "Sikatuna", "Dimiao"
  ],
  "Iloilo": [
    "Iloilo City", "Oton", "Santa Barbara", "Pavia", "Leganes",
    "Cabatuan", "Molo", "Jaro", "La Paz", "Mandurriao"
  ],
  "Negros Occidental": [
    "Bacolod", "Silay", "Talisay", "Kabankalan", "Sagay",
    "Cadiz", "San Carlos", "La Carlota", "Bago", "Victorias"
  ],
  "Negros Oriental": [
    "Dumaguete", "Bayawan", "Tanjay", "Bais", "Guihulngan",
    "Canlaon", "Sibulan", "Bacong", "Dauin", "Valencia"
  ],
  "Misamis Oriental": [
    "Cagayan de Oro", "El Salvador", "Villanueva", "Tagoloan", "Jasaan",
    "Opol", "Initao", "Gingoog", "Medina", "Balingoan"
  ],
  "Misamis Occidental": [
    "Ozamiz", "Oroquieta", "Tangub", "Jimenez", "Clarin",
    "Plaridel", "Aloran", "Lopez Jaena", "Tudela", "Panaon"
  ],
  "South Cotabato": [
    "General Santos", "Koronadal", "Polomolok", "Tupi", "Tampakan",
    "Surallah", "Lake Sebu", "Tboli", "Santo Niño", "Banga"
  ],
  "Zamboanga del Norte": [
    "Dipolog", "Dapitan", "Sindangan", "Liloy", "Polanco",
    "Piñan", "Labason", "Sergio Osmeña Sr.", "Sibutad", "Katipunan"
  ],
  "Zamboanga del Sur": [
    "Zamboanga City", "Pagadian", "Molave", "Aurora", "Tukuran",
    "Labangan", "Dimataling", "Dumalinao", "Mahayag", "Margosatubig"
  ],
  "Surigao del Norte": [
    "Surigao City", "Dapa", "Del Carmen", "San Isidro", "Placer",
    "Claver", "Mainit", "Malimono", "Sison", "Tagana-an"
  ],
  "Leyte": [
    "Tacloban", "Ormoc", "Palo", "Tanauan", "Baybay",
    "Carigara", "Dulag", "Abuyog", "Hilongos", "Javier"
  ],
  "Agusan del Norte": [
    "Butuan", "Cabadbaran", "Buenavista", "Nasipit", "Carmen",
    "Tubay", "Magallanes", "Jabonga", "Kitcharao", "Santiago"
  ],
  "Rizal": [
    "Antipolo", "Cainta", "Taytay", "Angono", "Binangonan",
    "Rodriguez", "San Mateo", "Teresa", "Tanay", "Morong"
  ],
  "Bulacan": [
    "Malolos", "Meycauayan", "San Jose del Monte", "Marilao", "Bocaue",
    "Balagtas", "Guiguinto", "Plaridel", "Pulilan", "Obando"
  ],
  "Pampanga": [
    "San Fernando", "Angeles", "Mabalacat", "Apalit", "Guagua",
    "Lubao", "Mexico", "Porac", "Floridablanca", "Sasmuan"
  ],
  "Batangas": [
    "Batangas City", "Lipa", "Tanauan", "Santo Tomas", "Nasugbu",
    "Balayan", "Lemery", "Rosario", "San Juan", "Bauan"
  ],
  "Laguna": [
    "Santa Rosa", "Biñan", "San Pedro", "Calamba", "Cabuyao",
    "Los Baños", "San Pablo", "Bay", "Pagsanjan", "Sta. Cruz"
  ],
  "Cavite": [
    "Dasmariñas", "Bacoor", "Imus", "General Trias", "Cavite City",
    "Tagaytay", "Silang", "Rosario", "Noveleta", "Tanza"
  ]
};

export const getProvinceCities = (province) => {
  return provinces[province] || [];
};

export const provinceList = Object.keys(provinces);
